var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import styles from './styles.module.scss';
import { arrayMove } from '../../../../infra/small-tools/array-utils';
import { getCellStylesFromCtx } from '../../../../infra/ui/table/utils';
var getRenderItem = function (items) {
    var RenderItem = function (provided, _snapshot, rubric) { return (_jsx("div", __assign({ className: styles.tr, ref: provided.innerRef }, provided.draggableProps, { children: items[rubric.source.index].getVisibleCells().map(function (cell) { return (_jsx("div", __assign({ className: "td", style: getCellStylesFromCtx({ ctx: cell.getContext(), stretchItems: 'flex' }) }, (cell.column.id === 'reorder' ? provided.dragHandleProps : {}), { children: flexRender(cell.column.columnDef.cell, cell.getContext()) }), cell.id)); }) }))); };
    RenderItem.displayName = 'RenderItem';
    return RenderItem;
};
export var WalkInTableView = function (_a) {
    var table = _a.table;
    var rows = table.getRowModel().rows;
    var headerGroups = table.getHeaderGroups();
    var isTableEmpty = rows.length === 0;
    var handleDragEnd = function (result) {
        if (!result.destination) {
            return;
        }
        arrayMove(rows, result.source.index, result.destination.index);
    };
    var renderItem = getRenderItem(rows);
    return (_jsxs("div", { className: styles.table, children: [_jsx("div", { children: headerGroups.map(function (headerGroup) { return (_jsx("div", { className: styles.thead, children: headerGroup.headers.map(function (header) { return (_jsx("div", { className: styles.th, style: getCellStylesFromCtx({ ctx: header.getContext(), stretchItems: 'flex' }), children: header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext()) }, header.id)); }) }, headerGroup.id)); }) }), _jsx(DragDropContext, { onDragEnd: handleDragEnd, children: _jsx(Droppable, { droppableId: "walkin-customers", renderClone: renderItem, children: function (droppableProvided) { return (_jsxs("div", __assign({ className: "tbody", ref: droppableProvided.innerRef }, droppableProvided.droppableProps, { children: [isTableEmpty && _jsx("div", { className: styles['empty-view'], children: "No clients found. Please try again." }), rows.map(function (row, index) {
                                var _a, _b;
                                return (_jsx(Draggable, { draggableId: row.id, index: index, isDragDisabled: !((_b = (_a = table.options.meta) === null || _a === void 0 ? void 0 : _a.reorderState) === null || _b === void 0 ? void 0 : _b.canReorder), children: renderItem }, row.id));
                            }), droppableProvided.placeholder] }))); } }) })] }));
};
